<template>
    <dropdown class="tracker-list-item-actions"
              :data-border="false"
              dataMenuWidth="115px"
              data-icon="mdi-dots-vertical"
              @hidden="hideEveryModal">
  
      <!-- <p class="marketing-email-list-item-actions-item pointer"
         @click.stop="showClientsModal">
        Vouchers
      </p> -->
  
      <p class="tracker-list-item-actions-item pointer"
         @click.stop="showEditModal">
        {{$t('message.generics.message.edit')}}
      </p>
  
      <p class="tracker-list-item-actions-item pointer"
         @click.stop="showDeleteModal">
        {{$t('message.generics.message.delete')}}
      </p>
  
      <confirmation-modal :value="showingSegmentDeleteModal"
                          :confirm-label="$t('message.generics.message.confirm')"
                          @confirm="deleteTracker"
                          @cancel="closeDeleteModal">
        <span slot="heading">
          Deletar Rastreador?
        </span>
        <span>
          Quer mesmo deletar este rastreador? Esta ação é irreversível
        </span>
      </confirmation-modal>
  
      <!-- <voucher-segment-create-modal :manual-show.sync="showingEditModal"
                                    :item="item"
                                    no-activator /> -->
  
      <tracker-create-modal :manual-show.sync="showingEditModal"
                            no-activator
                            :item="item" />
    </dropdown>
  </template>
  
  <script>  
  import TrackerCreateModal from "@components/modules/tracker/create/modal/TrackerCreateModal.vue";
  import ConfirmationModal from "@components/ConfirmationModal";
  import Dropdown from "@components/Dropdown";
  import EventBus from "@packages/event-bus";
  
  export default {
    components: {
      Dropdown,
      ConfirmationModal,
      TrackerCreateModal,      
    },
    data() {
      return {        
        showingEditModal: false,
        showingSegmentDeleteModal: false
      };
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
  
    computed: {},
    methods: {
    //   showClientsModal() {
    //     this.showingClientModal = true;
    //   },
      showEditModal() {
        this.showingEditModal = true;
      },
      hideEveryModal() {
        this.closeDeleteModal();
      },
      showDeleteModal() {
        this.showingSegmentDeleteModal = true;
      },
      closeDeleteModal() {
        this.showingSegmentDeleteModal = false;
      },
      async deleteTracker() {
        try {
          EventBus.$emit("SHOW_SPINNER");
  
          await this.$api.core.trackers.delete({
            id: this.item.id,
            type: this.item.type
          });
  
          EventBus.$emit("show-message", {
            type: "SUCCESS",
            message: "Rastreador deletado com sucesso",
          });
  
          this.closeDeleteModal();
  
          this.$emit("deleted");
        } catch (error) {
          // empty
        } finally {
          EventBus.$emit("CANCEL_SPINNER");
        }
      },
  
      goToEditPage() {},
  
      async duplicateEmail({ isAutomationFlow }) {
        await this.$api.marketing.email.message.duplicate({
          isAutomation: isAutomationFlow,
          emailId: this.item.id,
        });
  
        this.$emit("duplicated");
      },
  
      emitEdited() {
        this.$emit("edited");
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .tracker-list-item-actions {

    ::v-deep .dropdown-menu {
      right: 92%;
    }

    .tracker-list-item-actions-item {
      margin-bottom: 0px;
      font-size: 12px;
      color: #707070;
      font-weight: 600;
      margin-bottom: 5px;      
  
      &:hover {
        transform: translateY(-1px);
      }
  
      &:active {
        box-shadow: none;
        transform: translateY(1px);
      }
  
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  </style>
  